// Small presentation helpers shared across the intelligence views.

/** Human label for an interval in days, e.g. "every 6 weeks". */
export function humanizeInterval(days) {
  if (days == null) return '—';
  if (days <= 10) return `every ${days} day${days === 1 ? '' : 's'}`;
  if (days <= 45) {
    const w = Math.round(days / 7);
    return `every ${w} week${w === 1 ? '' : 's'}`;
  }
  if (days <= 400) {
    const m = Math.round(days / 30);
    return `every ${m} month${m === 1 ? '' : 's'}`;
  }
  const y = Math.round((days / 365) * 10) / 10;
  return `every ${y} year${y === 1 ? '' : 's'}`;
}

/** "12 days ago", "today", "in 5 days". */
export function relativeDays(days) {
  if (days == null) return '—';
  if (days === 0) return 'today';
  if (days > 0) {
    if (days === 1) return 'yesterday';
    if (days < 30) return `${days} days ago`;
    if (days < 365) return `${Math.round(days / 30)} mo ago`;
    return `${Math.round((days / 365) * 10) / 10} yr ago`;
  }
  const ahead = -days;
  if (ahead === 1) return 'tomorrow';
  if (ahead < 30) return `in ${ahead} days`;
  if (ahead < 365) return `in ${Math.round(ahead / 30)} mo`;
  return `in ${Math.round((ahead / 365) * 10) / 10} yr`;
}

/** Format an ISO date (YYYY-MM-DD) as "12 Mar 2024". */
export function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

/**
 * How long something ran, e.g. "12 days", "10 weeks". An ongoing span is a
 * lower bound and is marked with "+" so it is never read as a final figure.
 */
export function formatDuration(days, { ongoing = false } = {}) {
  if (days == null) return '—';
  const plus = ongoing ? '+' : '';
  if (days <= 45) return `${days}${plus} day${days === 1 && !ongoing ? '' : 's'}`;
  if (days <= 120) {
    const w = Math.round(days / 7);
    return `${w}${plus} week${w === 1 && !ongoing ? '' : 's'}`;
  }
  const m = Math.round(days / 30);
  return `${m}${plus} month${m === 1 && !ongoing ? '' : 's'}`;
}

/** Compact number, e.g. 1200 -> "1.2K". */
export function compactNumber(n) {
  if (n == null) return '0';
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return String(n);
}

export const MONTH_LABELS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];
